    /**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
controller('WebSiteCartCtrl', ["$window","$log","$scope","$filter","$location","$anchorScroll","$routeParams","HumanResourceData","DaySrv","AvailableTableView","SiteData",
    "BookingView","ServiceView","ImageData","$timeout","SaleView","DateSrv","gettextCatalog","CureItemData","CureItemSrv", "moment",
    function($window,$log,$scope,$filter,$location,$anchorScroll,$routeParams,HumanResourceData,DaySrv,AvailableTableView,SiteData,
             BookingView,ServiceView,ImageData,$timeout,SaleView,DateSrv,gettextCatalog, CureItemData, CureItemSrv, moment) {

        $scope.dd =
        {
            view :
            {
                displayError : false,
                waitServerResponse:false,
                errorMessage :'',
                warningBookingWeek : false,
                urlServiceMode : false,
                urlHrMode : false,
                cureDisplayError: false,
            }
        };

        $scope.$watch('ad.dataLoaded', function(newValue, oldValue)
        {
            if (newValue)// && !$scope.ad.view.currentServiceView)
            {
                if ($routeParams.serviceId)
                {
                    var serviceId =  parseInt($routeParams.serviceId);
                    var serviceView = $scope.getServiceViewById(serviceId);
                    if (serviceView) {
                        if ($scope.ad.view.currentBookingView)//RESET
                            $scope.ad.view.currentBookingView = null;
                        $scope.addBookingServiceViewDirect(serviceView);
                        $scope.dd.view.urlServiceMode = true;
                    }

                    if ($routeParams.hrMail && $routeParams.hrMail!='') {
                        var hrView = $scope.getHrView(HumanResourceData.getByEmail($routeParams.hrMail));

                        if (hrView)
                            $scope.dd.view.urlHrMode = true;
                        if ($scope.ad.view.currentBookingView != null) {
                            if ($scope.ad.view.aTableView && $scope.ad.view.currentBookingView) {
                                $scope.removeSelectedTime();
                                $scope.ad.view.aTableView = null;
                                $scope.ad.view.currentBookingView.date = new Date();
                            }
                            let isNextWeek = true
                            DaySrv.getAvailablePeriods(new Date(), 7, isNextWeek,
                                function (loadedDays, hrSelected, nextDay) {
                                $scope.afterGetAvailablePeriods(loadedDays, hrView, nextDay, isNextWeek);
                            });

                        }
                    }
                    else
                    {
                        if ($scope.ad.view.currentBookingView!=null)
                        {
                            if ($scope.ad.view.aTableView && $scope.ad.view.currentBookingView)
                            {
                                $scope.removeSelectedTime();
                                $scope.ad.view.aTableView = null;
                                $scope.ad.view.currentBookingView.date = new Date();
                            }
                            DaySrv.getAvailablePeriods(new Date(),7,true, $scope.afterGetAvailablePeriods);

                        }

                    }

                }
            }
        });

        $scope.addBookingServiceViewDirect = function (serviceView) {
            $scope.ad.view.currentServiceView = serviceView;

            if ($scope.ad.view.currentBookingView == null)
                $scope.ad.view.currentBookingView = new BookingView(null, -1, $scope);
            var citsView = null;
            if ($scope.ad.view.customerView)
                citsView = $scope.ad.view.customerView.getFirstCureItemToServiceViewByServiceView(serviceView);
            if (citsView)
                $scope.addServiceOnBookingOnUserSelectCureItem(citsView);
            else {
                if ($scope.ad.view.currentSaleView && $scope.ad.view.currentBookingView) {
                    $scope.ad.view.currentBookingView.saleView = $scope.ad.view.currentSaleView;
                    $scope.ad.view.currentSaleView.bookingView = $scope.ad.view.currentBookingView;
                }
                $scope.ad.view.currentBookingServiceView = $scope.ad.view.currentBookingView.addServiceOnBooking($scope.ad.view.currentServiceView);
            }
        };

        $scope.afterGetAvailablePeriods = function(loadedDays,previousSelectedHr, nextAvailableDay, isNextWeek) {
            if (nextAvailableDay && nextAvailableDay !== $scope.ad.view.currentBookingView.date) {
                $scope.ad.view.currentBookingView.date = nextAvailableDay;
            }

            $scope.ad.view.aTableView = new AvailableTableView(SiteData.defaultSite,$scope);
            let availableHumanResources = [];
            let isAvailable;
            let dayHr;
            let hrId ;

            for (let i=0;i<$scope.ad.view.humanResourcesView.length;i++) {
                isAvailable = false;
                hrId = $scope.ad.view.humanResourcesView[i].getModel().id;
                for (let j=0;j<loadedDays.length && !isAvailable;j++) {
                    if (loadedDays[j]) {
                        dayHr = loadedDays[j].getDayHrByHrId(hrId);
                        if (dayHr && dayHr.availablePeriods && dayHr.availablePeriods.length>0) {
                            isAvailable = true;
                        }
                    }
                }
                if (isAvailable) {
                    availableHumanResources.push($scope.ad.view.humanResourcesView[i]);
                }
            }

            if ($scope.ad.adminEdition && !$scope.ad.view.currentBookingServiceView.getModel()) {
                $scope.humanResourcesViewSelectable =  availableHumanResources;
            } else if ($scope.ad.view.currentBookingView) {
                $scope.humanResourcesViewSelectable = $scope.ad.view.currentBookingView.getHumanResourcesViewWhoKnow(availableHumanResources);//check hr who know
            }

            if (previousSelectedHr && ($scope.dd.view.urlHrMode || $scope.humanResourcesViewSelectable.indexOf(previousSelectedHr) !== -1)) {
                $scope.ad.view.aTableView.selected.humanResourceView = previousSelectedHr;
            }
            $scope.ad.view.aTableView.updateAvailability($scope.ad.view.currentBookingView);

            if ($scope.ad.appAttributes.discountDays) {
                $scope.ad.view.aTableView.setByDiscountDays($scope.ad.appAttributes.discountDays);
            }

            if ($scope.ad.view.aTableView && !$scope.ad.view.aTableView.selected.hasAvailability) {
                isNextWeek = isNextWeek === undefined ? true : isNextWeek;
                let currentMonday = moment(new Date()).day(1);
                if (moment($scope.ad.view.currentBookingView.date).isSameOrAfter(currentMonday, 'day')) {
                    $scope.displayWeek(isNextWeek);
                }
            }
        };

        $scope.getClassForSelectedHumanResource = function(humanRessourceView,className)
        {
            if ($scope.isTheSelectedHumanResource(humanRessourceView))
                return className;
            return "";
        };

        $scope.getClassForAllowBooking = function(className)
        {
            if ($scope.ad.view.aTableView!=null && $scope.ad.view.aTableView.selected.aTimeView!=null)
                return className;
            return "";
        };

        $scope.isTheSelectedHumanResource = function(humanRessourceView)
        {
            if ($scope.ad.view.aTableView!=null && humanRessourceView===$scope.ad.view.aTableView.selected.humanResourceView)
                return true;
            else
                return false;
        };

        $scope.setSelectedHumanResource = function(humanRessourceView)
        {
            if ($scope.ad.view.currentBookingView!=null && $scope.ad.view.aTableView && $scope.ad.view.aTableView.selected)
            {
                $scope.ad.view.aTableView.selected.humanResourceView = humanRessourceView;
                $scope.ad.view.aTableView.selected.aSlotView = null;
                $scope.ad.view.aTableView.selected.aTimeView = null;
                $scope.ad.view.aTableView.updateAvailability($scope.ad.view.currentBookingView);
            }
        };

        $scope.displayWeek = function (next) {
            const numberDaysOfWeek = 7;
            if ($scope.ad.view.currentBookingView != null) {
                let date = new Date($scope.ad.view.currentBookingView.date);
                if (next) {
                    date.setDate(date.getDate() + numberDaysOfWeek);
                } else {
                    date.setDate(date.getDate() - numberDaysOfWeek);
                }

                let currentDate = new Date();
                if (DateSrv.daysBetween(date, currentDate) > (numberDaysOfWeek * $scope.ad.appAttributes.nbBookingWeeks)) {
                    $scope.dd.view.warningBookingWeek = true;
                } else {
                    let day = currentDate.getDay();
                    let dayOfWeekDiff = day === 0 ? -6 : 1;
                    if (moment(date).isSameOrAfter(moment(currentDate).day(dayOfWeekDiff), 'day')) {
                        $scope.dd.view.warningBookingWeek = false;
                        $scope.ad.view.currentBookingView.date = date;
                        let selectedHr = null;
                        if ($scope.ad.view.aTableView && $scope.ad.view.aTableView.selected && ($scope.dd.view.urlHrMode || $scope.ad.appAttributes.allowChooseHr)) {//preserve hr selection when go to next week
                            selectedHr = $scope.ad.view.aTableView.selected.humanResourceView;
                        }
                        $scope.ad.view.aTableView = null;
                        $scope.humanResourcesViewSelectable = [];
                        DaySrv.getAvailablePeriods(date, numberDaysOfWeek, next,
                            function (loadedDays, hrSelected, nextDay) {
                                $scope.afterGetAvailablePeriods(loadedDays, selectedHr, nextDay, next);
                            });
                    }
                }
            }
        };

        $scope.setSelectedSlotAndTime = function(aDayView,aSlotView,aTimeView) {
            $scope.setSelectedSlot(aDayView,aSlotView,true);
            $scope.setSelectedTime(aTimeView);
        }

        $scope.setSelectedSlot = function(aDayView,aSlotView,force) {
            if ($scope.ad.view.currentBookingView!=null && aDayView!=null && aSlotView && aSlotView.aTimesView.length>0)
            {
                if ((force!== undefined && force) || $scope.ad.view.aTableView.selected.aSlotView!==aSlotView)
                {
                    $scope.ad.view.currentBookingView.date=aDayView.date;
                    $scope.ad.view.currentBookingView.aDayView=aDayView;
                    $scope.ad.view.aTableView.selected.aSlotView = aSlotView;
                }
                else
                    $scope.ad.view.aTableView.selected.aSlotView = null;
            }
        };

        $scope.removeSelectedTime = function()
        {
            if ($scope.ad.view.currentBookingView!=null) {
                if ($scope.ad.view.aTableView.selected.aTimeView)//remove
                    for (var i = 0; i < $scope.ad.view.currentBookingView.bookingServicesView.length; i++) {
                        $scope.ad.view.currentBookingView.bookingServicesView[i].updateService();//restore price if time discout
                    }
            }
            $scope.ad.view.aTableView.selected.aTimeView = null;
        };

        $scope.handleBookingServiceHrRequest = function (bookingServiceView) {
            const requestedHr = $scope.ad.view.aTableView.selected.humanResourceView;
            bookingServiceView.hrRequest = requestedHr && $scope.ad.appAttributes.allowChooseHr;
            bookingServiceView.subBsView.forEach(subBookingServiceView =>
                subBookingServiceView.hrRequest = bookingServiceView.hrRequest);
        };

        $scope.setSelectedTime = function(aTimeView)
        {
            if ($scope.ad.view.currentBookingView!=null && aTimeView)
            {
                $scope.ad.view.aTableView.selected.aTimeView = aTimeView;
                $scope.ad.view.currentBookingView.moveToStart(aTimeView.period.start);

                $scope.ad.view.currentBookingView.bookingServicesView.forEach(bookingServiceView => {
                    bookingServiceView.updateService();
                    $scope.handleBookingServiceHrRequest(bookingServiceView);
                    if ($scope.ad.view.aTableView.selected.aSlotView) {
                        bookingServiceView.addDiscount($scope.ad.view.aTableView.selected.aSlotView.discount);
                    }
                });

                //scroll to verification time
                if ($(document).scrollTop()!=0)
                    $timeout(//use timeout to allow angular to render view
                        function()
                        {
                            $('html, body').animate({
                                scrollTop: $("#time-selected").offset().top
                            }, 500);
                        },100
                    )
            }
        };


        $scope.checkOut = function() {
            if ($scope.ad.view.currentBookingView != null && $scope.ad.view.currentBookingView.aDayView  && $scope.ad.view.aTableView
                    && $scope.ad.view.aTableView.selected  && $scope.ad.view.aTableView.selected.aTimeView != null) {

                if ($scope.ad.view.currentBookingView.aDayView.setResourcesOnBooking($scope.ad.view.currentBookingView)) {
                    if (!$scope.ad.view.currentSaleView) {
                        $scope.ad.view.currentSaleView = new SaleView(null, -1, null, $scope.ad.view.currentBookingView, $scope.ad.view);
                        $scope.ad.view.currentSaleView.isCreatedByCustomer = true;
                        $scope.ad.view.currentBookingView.saleView = $scope.ad.view.currentSaleView;
                        $scope.ad.view.currentSaleView.bookingView = $scope.ad.view.currentBookingView;
                    }
                    $scope.openLocation("checkout");
                } else {
                    $scope.ad.view.errorMessage = gettextCatalog.getString("Vous devez sélectionner une date pour votre réservation");
                    let selectedHr = null;
                    if ($scope.ad.view.aTableView && $scope.ad.view.aTableView.selected && ($scope.dd.view.urlHrMode
                            || $scope.ad.appAttributes.allowChooseHr)) {
                        selectedHr = $scope.ad.view.aTableView.selected.humanResourceView;
                    }
                    let date = $scope.ad.view.currentBookingView.date;
                    $scope.removeSelectedTime();
                    $scope.ad.view.aTableView = null;
                    $scope.ad.view.currentBookingView.date = null;

                    let isNextWeek = true;
                    DaySrv.getAvailablePeriods(date, 7, isNextWeek,
                        function (loadedDays, hrSelected, nextDay) {
                            $scope.afterGetAvailablePeriods(loadedDays, selectedHr, isNextWeek);
                    });
                }
            } else {
                $scope.ad.view.errorMessage = gettextCatalog.getString("Vous devez sélectionner une date pour votre réservation");
            }
        };

        $scope.checkIfCureItemServicesIsUsedAndCheckOut = function(currentBookingView) {
            let cureItemsService = currentBookingView.getCureItemsService();
            CureItemSrv.checkCureItemServiceIsUsed(cureItemsService, function (data) {
                let cureItemServices = data.cureItemServices;
                if(cureItemServices != null && cureItemServices.length > 0){
                    for(let i=0; i < currentBookingView.bookingServicesView.length; i++){
                        for(let j=0; j < cureItemServices.length; j++){
                            if(currentBookingView.bookingServicesView[i].cureItemToServiceUsageView.cureItemToServiceView.cureItemView.cureItemId === cureItemServices[j].cureItemId){
                                currentBookingView.bookingServicesView[i].price = currentBookingView.bookingServicesView[i].cureItemToServiceUsageView.cureItemToServiceView.serviceView.price;
                                $scope.ad.view.currentBookingView.price += currentBookingView.bookingServicesView[i].price;
                            }
                        }
                    }
                }
                $scope.checkOut();

            }, function (data){
                if((data == null) || data.status == null || data.status !== "200"){
                    $scope.dd.view.serverAlert = true;
                }});
        };

        $scope.afterSaveCurrentBooking = function(bookingRes)
        {
            $scope.dd.view.waitServerResponse = false;
            $scope.ad.view.bookedBookingView = $scope.ad.view.currentBookingView;
            $scope.ad.view.currentBookingView = null;
            if ($scope.ad.appAttributes.googleAnalyticsId && $scope.ad.appAttributes.googleAnalyticsId!='') {
                let dataLayer = $window.dataLayer = $window.dataLayer || [];
                dataLayer.push({event: 'page_change',
                    attributes: {
                        route: '/rendezvous/finalise'
                    },
                });
            }

            if (typeof analytics !== 'undefined' && analytics)
                analytics.track("Booking Demo Signed Up");

            $scope.openLocation("account");
        };

        $scope.afterSaveError = function(errorMessage)
        {
            DaySrv.getAvailablePeriods(new Date(),7,true, function ()
            {
                $scope.ad.view.aTableView = new AvailableTableView(SiteData.defaultSite,$scope);
                $scope.ad.view.aTableView.updateAvailability($scope.ad.view.currentBookingView);
                $scope.dd.view.waitServerResponse = false;
                $scope.ad.view.errorMessage = errorMessage;//$scope.openLocation("account");
            });
        };

        $scope.canBook = function () {
            if (!$scope.ad.view.currentBookingView) {
                return false;
            }
            if ($scope.ad.offerManager.hasAccessToFeature($scope.ad.subscriptions, $scope.ad.storeAppCode.OPTION_WEBSITE_PAYMENT) && $scope.ad.appAttributes.hasBookingPayment) {
                if ($scope.ad.appAttributes.hasBookingPaymentAdvance) {
                    return true;
                } else {
                    return !$scope.hasMandatoryPayment();
                }
            } else {
                return true;
            }
        };

        $scope.clearErrorMessage = function () {
            if (!$scope.ad.view.currentBookingView
                || ($scope.ad.view.currentBookingView && !$scope.ad.view.currentBookingView.bookingServicesView)
                || ($scope.ad.view.currentBookingView
                    && $scope.ad.view.currentBookingView.bookingServicesView
                    && $scope.ad.view.currentBookingView.bookingServicesView.length === 0)) {
                $scope.ad.view.errorMessage = "";
            }
        };

        $scope.hasMandatoryPayment = function()
        {
            if ($scope.ad.appAttributes.hasBookingPaymentMandatory)
                return true;
            if ($scope.ad.appAttributes.hasBookingPaymentOnAmount && $scope.ad.view.currentBookingView.price>$scope.ad.appAttributes.bookingPaymentOnAmount)
                return true;
            for (var i=0;i<$scope.ad.view.currentBookingView.bookingServicesView.length;i++)
                if ($scope.ad.view.currentBookingView.bookingServicesView[i].serviceView.hasMandatoryPayment)
                    return true;
            return false;
        };

        $scope.displayPreviousWeekButton = function() {
            return moment($scope.ad.view.currentBookingView.date).isAfter(new Date(), 'day');
        }

        //START CODE
        $scope.clearErrorMessage();
        if ($scope.ad.adminEdition)
        {
            if ($scope.ad.view.currentBookingView==null)
                $scope.ad.view.currentBookingView = new BookingView(null,-1,$scope.$parent);
            console.log($scope.ad.view.currentBookingView);
            if ($scope.ad.view.currentBookingView.bookingServicesView.length==0)
            {
                var serviceViewExample = new ServiceView(null,-1,null,$scope);
                serviceViewExample.label =  "Exemple de prestation";
                serviceViewExample.price = 59;
                serviceViewExample.itnDurationD = 40;
                serviceViewExample.nbHrsNeeded = 0;
                var images = ImageData.getActiveList("");
                if (images && images.length!=0)
                    serviceViewExample.imageDisplayed = images[0];
                $scope.ad.view.currentBookingServiceView = $scope.ad.view.currentBookingView.addServiceOnBooking(serviceViewExample) ;
                //$scope.ad.view.aTableView.updateAvailability($scope.ad.view.currentBookingView);

            }

        }
        if ($scope.ad.view.currentBookingView!=null && !$scope.dd.view.urlServiceMode)
        {
            if ($scope.ad.view.aTableView && $scope.ad.view.currentBookingView)
            {
                $scope.removeSelectedTime();
                $scope.ad.view.aTableView = null;
                $scope.ad.view.currentBookingView.date = new Date();
            }
            DaySrv.getAvailablePeriods(new Date(),7,true, $scope.afterGetAvailablePeriods);

        }

    }]);



// WEBPACK FOOTER //
// ./js/controllers/customerSite/WebSiteCartCtrl.js